module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/home/empty-home/empty-home.component.scss
// module id = ./src/app/home/empty-home/empty-home.component.scss
// module chunks = main